// extracted by mini-css-extract-plugin
module.exports = {"cookie":"cookie-module--cookie--WpfbT","title":"cookie-module--title--352mw","button":"cookie-module--button--Kube8"};